import React, { PropTypes } from "react";

export default function StepperView({ value, step, min, label, onInputChange, onInputBlur, onDecrease, onIncrease }) {
    return (<div className="input-group stepper">
        <span className="stepper-field field-label">
            <span className="meta-label">{label}</span>
            <input
              type="text"
              className="form-control"
              value={value}
              onChange={onInputChange}
              onBlur={onInputBlur}
            />
        </span>
      </div>);
}

StepperView.propTypes = {
    value: PropTypes.number.isRequired,
    /*label: PropTypes.string.isRequired,*/
    step: React.PropTypes.number,
    min: React.PropTypes.number,
    onInputChange: React.PropTypes.func.isRequired,
    onInputBlur: React.PropTypes.func.isRequired,
    onDecrease: React.PropTypes.func.isRequired,
    onIncrease: React.PropTypes.func.isRequired,
};

StepperView.defaultProps = {
    step: 1,
    min: 1,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Common/Views/StepperView.jsx